import * as React from "react";
import { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

// MUI
import {
    DataGridPro,
    GridToolbarContainer,
    useGridApiRef,
} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {blue, deepOrange, deepPurple, teal} from "@mui/material/colors";

// App
import { getCdpHierarchy } from "../../ContractDataPoint/ContractDataPointClient";
import { changeWorkQueue } from "../workQueueSlice";
import VersionAvatarConfig from "../../CommonComponents/VersionAvatarConfig";
import WorkQueueFoldersInfoDialogue from "./Info/WorkQueueFoldersInfoDialogue";

export default function WorkQueueFolders(props) {
    const [workQueueCDP, setWorkQueueCDP] = useState([]);

    const [workQueueFoldersInfoOpen, setWorkQueueFoldersInfoOpen] = useState(false);


    const selectorContractSectionContractId = useSelector(
        (state) => state.workQueueSlc.value.selectedContractId
    );

    const workQueueCSGridRefresh = useSelector(
        (state) => state.workQueueSlc.value.workQueueCSGridRefresh
    );

    const dispatchData = useDispatch();
    const apiRef = useGridApiRef();

    //
    // useEffect(() => {
    //     fetchWorkQueueCDP();
    //     dispatchData(changeWorkQueue({ workQueueCSGridRefresh: false }));
    // }, [workQueueCSGridRefresh]);
    //
    // const fetchWorkQueueCDP = () => {
    //     console.log("Folder hierarchy fetch triggered");
    //     console.log("hierarchy contract id ", selectorContractSectionContractId);
    //
    //     if (selectorContractSectionContractId > 0) {
    //         getCdpHierarchy(selectorContractSectionContractId)
    //             .then((res) => res.data)
    //             .then((data) => {
    //                 console.log("Hierarchy data");
    //                 console.log(data);
    //                 setWorkQueueCDP(data);
    //             });
    //     } else {
    //         setWorkQueueCDP([]);
    //     }
    // };

    const fetchWorkQueueCDP = React.useCallback(() => {
        console.log("Folder hierarchy fetch triggered");
        console.log("hierarchy contract id ", selectorContractSectionContractId);

        if (selectorContractSectionContractId > 0) {
            return getCdpHierarchy(selectorContractSectionContractId)

                .then(data => {
                    console.log("Hierarchy data");
                    console.log(data);
                    setWorkQueueCDP(data);
                });
        }

        setWorkQueueCDP([]);
        return Promise.resolve();
    }, [selectorContractSectionContractId]);


    useEffect(() => {
        if (!workQueueCSGridRefresh) return;

        fetchWorkQueueCDP().finally(() => {
            dispatchData(changeWorkQueue({ workQueueCSGridRefresh: false }));
        });
    }, [workQueueCSGridRefresh, fetchWorkQueueCDP, dispatchData]);


    const handleExplore = (data) => {
        dispatchData(
            changeWorkQueue({
                selectedContractSectionId: data.folderId,
                selectedContractSectionHierarchy: data.hierarchy,
                selectedVersionNumber: data.versionNumber,
            })
        );
        dispatchData(changeWorkQueue({ workQueueCDPGridRefresh: true }));
    };

    const handleHeaderClick = () => {
        dispatchData(
            changeWorkQueue({
                selectedContractSectionId: 0,
                selectedContractSectionHierarchy: null,
                workQueueCDPGridRefresh: true,
            })
        );
    };

    const getTreeDataPath = useCallback((row) => row.hierarchy.split("|"), []);

    const columns = useMemo(
        () => [
            {
                field: "ordinalNumber",
                headerName: "cs",
                sortable: true,
                width: 30,
                hide: true,
            },
        ],
        []
    );

    function CustomToolbar() {
        return (
            <GridToolbarContainer sx={{ bgcolor: "background.paper" }}>
                <Box
                    sx={{
                        height: 32,
                        flexGrow: 1,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Typography
                        onClick={handleHeaderClick}
                        sx={(theme) => ({
                            ...theme.typography.body2,
                            fontWeight: theme.typography.fontWeightMedium,
                            color: "text.primary",
                            cursor: "pointer",
                            pl: 1,
                            whiteSpace: "nowrap",
                        })}
                    >
                        All Folders
                    </Typography>
                </Box>
            </GridToolbarContainer>
        );
    }


    const groupingColDef = useMemo(
        () => ({
            headerName: "Folders",
            description: "Contract folder hierarchy",
            width: 300,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const row = params.row;
                const showAvatar = row?.versionNumber > 0;
                const showTestBadge = row?.versionMode === "Test";

                const rowNode = params.rowNode;
                const expanded = !!rowNode.childrenExpanded;
                const hasChildren =
                    rowNode.type === "group" ||
                    (Array.isArray(rowNode.children) && rowNode.children.length > 0) ||
                    rowNode.childrenFromPath?.length > 0;
                const rawLabel = params.formattedValue ?? params.value ?? "";
                const label = rawLabel.replace(/\s+v\.\d+$/, "");
                // const label = params.formattedValue ?? params.value ?? "";
                const versionTooltip = params.row.versionNumber ? `version ${params.row.versionNumber}` : "";
                const versionScenario = params.row.versionScenario ?? "";
                const folderDescription = params.row.folderDescription  ?? "";
                const {
                    avatarLetter,
                    avatarBg,
                    avatarTooltip,
                    badgeLetter,
                    badgeBg,
                    badgeTooltip,
                } = VersionAvatarConfig(row);
            // } = getFolderAvatarConfig(row);

                const handleToggle = (event) => {
                    event.stopPropagation();
                    apiRef.current.setRowChildrenExpansion(params.id, !expanded);
                };

                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            minWidth: 0,
                            overflow: "hidden",
                        }}
                    >
                        {hasChildren ? (
                            <IconButton
                                size="small"
                                onClick={handleToggle}
                                sx={{ mr: 0.5, p: 0.25 }}
                            >
                                {expanded ? (
                                    <KeyboardArrowDownIcon fontSize="small" />
                                ) : (
                                    <KeyboardArrowRightIcon fontSize="small" />
                                )}
                            </IconButton>
                        ) : (
                            <Box sx={{ width: 24, mr: 0.5 }} />
                        )}
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={versionTooltip || folderDescription} arrow>
                            {/*<Tooltip title={versionTooltip || "Folder"} arrow>*/}
                            <Box
                                component="span"

                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    minWidth: 0,
                                    pr: 1,
                                    ...(showAvatar && { width: 90 })
                                }}
                            >
                                {label}
                            </Box>
                        </Tooltip>
                        {showAvatar && (

                            <Box
                                component="span"
                                sx={{
                                    position: "relative",
                                    display: "inline-block",
                                    width: 20,
                                    height: 20
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Tooltip enterDelay={1000} enterNextDelay={1000} title={avatarTooltip} arrow>
                                    <Avatar
                                        sx={{
                                            bgcolor: avatarBg,
                                            width: 20,
                                            height: 20,
                                            fontSize: 14
                                        }}
                                    >
                                        {avatarLetter}
                                    </Avatar>
                                </Tooltip>

                                {/* FREQUENCY badge */}
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        zIndex: 1,
                                        "& .MuiBadge-badge": {
                                            transform: "translate(65%, -35%)",
                                        },
                                    }}
                                    badgeContent={
                                        <Tooltip enterDelay={1000} enterNextDelay={1000} title={badgeTooltip} arrow>
                                            <Box component="span">
                                                <Avatar
                                                    sx={{
                                                        width: 12,
                                                        height: 12,
                                                        fontSize: 12,
                                                        bgcolor: badgeBg,
                                                    }}
                                                >
                                                    {badgeLetter}
                                                </Avatar>
                                            </Box>
                                        </Tooltip>
                                    }
                                />

                                {/* MODE badge */}
                                {(showTestBadge) && (
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{
                                            vertical: "top",
                                            horizontal: "right"
                                        }}
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            zIndex: 2,
                                            "& .MuiBadge-badge": {
                                                transform: "translate(105%, -35%)"
                                            }
                                        }}
                                        badgeContent={
                                            <Tooltip enterDelay={1000} enterNextDelay={1000} title={`Test Scenario ${versionScenario}`} arrow>
                                                <Box component="span">
                                                    <Avatar
                                                        sx={{
                                                            width: 12,
                                                            height: 12,
                                                            fontSize: 12,
                                                            bgcolor: "black"
                                                        }}
                                                    >
                                                        {versionScenario}
                                                        {/*t*/}
                                                    </Avatar>
                                                </Box>
                                            </Tooltip>
                                        }
                                    />
                                )}
                            </Box>

                        )}

                    </Box>
                );
            },
        }),
        [apiRef]
    );


    const handleWorkQueueFoldersInfo = () => {
        setWorkQueueFoldersInfoOpen(true);
    };

    const handleCloseWorkQueueFoldersInfo = () => {
        setWorkQueueFoldersInfoOpen(false);
    };


    return (
        <Box
            sx={{
                height: 800,
                width: 200,
                "& .exception-row": {
                    color: "red",
                },
            }}
        >
            <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                style={{ cursor: "pointer" }}
                onClick={() => handleWorkQueueFoldersInfo()}
            >
                Contract Folders
            </Typography>
            </Tooltip>
                <WorkQueueFoldersInfoDialogue
                    open={workQueueFoldersInfoOpen}
                    onClose={handleCloseWorkQueueFoldersInfo}
                />
                <DataGridPro
                apiRef={apiRef}
                getRowClassName={(params) =>
                    params.row.exception === "Exception" ? "exception-row" : ""
                }
                headerHeight={0}
                treeData
                style={{
                    height: "100% - 20px",
                    width: "100%",
                    backgroundColor: "rgb(137,207,240)",
                    cursor: "pointer",
                }}
                sx={{
                    "& .MuiDataGrid-footerContainer": {
                        backgroundColor: "#fff",
                    },
                    "& .MuiTablePagination-root": {
                        backgroundColor: "#fff",
                    },
                }}
                aria-label="WorkQueueFolders"
                rows={workQueueCDP}
                getRowId={(row) => row.folderRow}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                rowThreshold={0}
                disableDensitySelector
                disableColumnSelector
                columns={columns}
                density="compact"
                pageSize={50}
                rowsPerPageOptions={[50]}
                onRowClick={(params) => handleExplore(params.row)}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "folderRow", sort: "asc" }],
                    },
                }}
                components={{
                    Toolbar: CustomToolbar,
                }}
            />
        </Box>
    );
}